module.exports = __webpack_public_path__ + "img/tree-decorated.d4c62d78.svg";